import { render, staticRenderFns } from "./PasswordResetCode.vue?vue&type=template&id=f6de2174&"
import script from "./PasswordResetCode.vue?vue&type=script&lang=js&"
export * from "./PasswordResetCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports